import type { Id } from "./id";

export enum NotificationPriority {
    Error = "error",
    Warning = "warning",
    Info = "info",
    Validation = "validation",
}

export enum NotificationKey {
    CommissionNotFulfilled = "commission-not-fulfilled",
    NewExternalPosChannel = "new-external-pos-channel",
    OrganizationInvalidCredential = "organization-invalid-credential",
    OrganizationMissingCredential = "organization-missing-credential",
    PosMissingCredential = "pos-no-credential",
    PosInvalidCredential = "pos-invalid-credential",
    PosMissingOpeningHours = "pos-opening-hours",
    PosMissingSepa = "pos-missing-sepa",
    PosOfferMissingProducts = "pos-offer-no-product",
    PosOfferError = "pos-error-offer",
    PosOfferAlreadyOnline = "pos-online-offer",
    PosMarketingActionAlreadyOnline = "pos-online-marketing-action",
    PosCredentialValidation = "pos-credential-validation",
    PosMarketingActionNotQualified = "pos-marketing-action-not-qualified",
    PosOfferNotQualified = "pos-offer-not-qualified",
    SpecialOfferNoLongerAvailable = "special-offer-no-longer-available",
    MealDealOfferNotPushed = "meal-deal-offer-not-pushed",
    ActionSlotNotCreated = "action-slot-not-created",
}

export interface Notification {
    id: Id;
    key: NotificationKey;
    // JSON
    parameters: any;
    priority: NotificationPriority;
    createdDateUTC: Date;
    updatedDateUTC: Date;
    seenDateUTC?: Date;
}
